import { ANCHOR_PRODUCT } from "../constants";
import { getLocation } from "../../router/selectors";
import { updateLocationQuery } from "../../router/actions";

export const anchorProductToUrl = ({ productTileId, pageNumber }) => (
  dispatch,
  getState
) => {
  dispatch({ type: ANCHOR_PRODUCT });

  const { query } = getLocation(getState());

  dispatch(
    updateLocationQuery({
      query: {
        ...query,
        scrollTo: productTileId,
        page: pageNumber > 1 ? pageNumber : undefined
      }
    })
  );
};
